module.exports = __WEBPACK_EXTERNAL_MODULE__sav_remoteEntry_mjs_a3cc726b__;